import { Flex, Paper, Stack, Title } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import {
  resolveDefaultAppPath,
  shouldDeferRouteGuard,
} from '@auth/data-access';
import { ROLES, useSharedQueries } from '@data-access';
import { ConnectivityCard } from '@ui';

export const Route = createFileRoute('/_app/import')({
  beforeLoad(ctx) {
    const { auth } = ctx.context;

    if (shouldDeferRouteGuard(auth)) {
      return;
    }

    if (auth.user?.user_access !== ROLES.ADMIN) {
      throw redirect({
        to: resolveDefaultAppPath(auth.user),
      });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation();
  const sharedQueries = useSharedQueries();

  const connectivity = useQuery(sharedQueries.connectivity());

  return (
    <Stack>
      <Paper p="md">
        <Title order={2}>{t('connectivity.import-title')}</Title>
      </Paper>
      <Flex gap="md" justify="flex-start" wrap="wrap">
        {connectivity.data?.connectivity.map((c) => (
          <ConnectivityCard key={c.id} {...c} />
        ))}
      </Flex>
    </Stack>
  );
}
